import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from "src/app/services/app-config.service";
import { TipologiaSisma } from "../models/tipologia-sisma";

@Injectable({
    providedIn: "root"
})
export class TipologiaSismaService {
    private apiUrl = `${AppConfigService.env.api_endpoint}${AppConfigService.env.endpoints.inframob}TipologieSisma/`;
    constructor(private http: HttpClient) { }

    getAllDt(dataTablesParameters: any) {
        return this.http.post<any>(
            `${this.apiUrl}alldt`,
            dataTablesParameters
        );
    }
    getAll() {
        return this.http.get<TipologiaSisma[]>(
            `${this.apiUrl}`
        );
    }

    insert(s: TipologiaSisma) {
        return this.http.post<any>(`${this.apiUrl}`, s);
    }
    update(s: TipologiaSisma) {
        return this.http.put<any>(`${this.apiUrl}${s.id}`, s);
    }
    delete(id: number) {
        return this.http.delete<any>(`${this.apiUrl}${id}`);
    }
    save(s:TipologiaSisma){
        if (!s.id)return this.insert(s);
        return this.update(s);
    }

}
